import React from "react";
import "./Card.scss";
import Button from "../Button/Button";
const Card = ({
  headerText,
  Ndays,
  Company,
  tours,
  sleep,
  difficulity,
  cost,
  numofcard,
}) => {
  return (
    <section>
      <div className="card">
        <div className="card-side card-side-front">
          <div className={`card-picrure card-picture-${numofcard}`}>&nbsp;</div>
          <h4 className="card-heading">
            <span
              className={`card-heading-span card-heading-span-${numofcard}`}
            >
              {headerText}
            </span>
          </h4>
          <div className="card-details">
            <ul>
              <li>{Ndays} day</li>
              <li>up to {Company} people</li>
              <li>{tours} tour guide</li>
              <li>{sleep}</li>
              <li>difficulty : {difficulity}</li>
            </ul>
          </div>
        </div>
        <div className={`card-side card-side-back card-side-back-${numofcard}`}>
          <div className="card-cta">
            <div className="card-price-box">
              <p className="card-price-only">Only</p>
              <p className="card-price-value">₣{cost}</p>
            </div>
            <Button href="#popup" text="Book!" btnColor="btn-color-white" />
          </div>
        </div>
      </div> 
    </section>
  );
};

export default Card;
